import { render, staticRenderFns } from "./createOpportunity.vue?vue&type=template&id=10551ec1&scoped=true"
import script from "./createOpportunity.vue?vue&type=script&lang=js"
export * from "./createOpportunity.vue?vue&type=script&lang=js"
import style0 from "./createOpportunity.vue?vue&type=style&index=0&id=10551ec1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10551ec1",
  null
  
)

export default component.exports